import { FinancialStatement } from '../../../../financial-statement/models/common/FinancialStatement';
import { ExcelTemplate } from '../../../interfaces';
import * as XLSX from 'xlsx-js-style';
import { getPreparedData } from './mappings';
import { fitToColumn } from '../utils';
import { withHeaderStyling } from '../../../utils';

export class AssemblyTemplate implements ExcelTemplate {
  headers = [
    'Part name',
    'Item name',
    'Trial balance(original)',
    'Debit adjustment',
    'Credit adjustment',
    'Trial balance(after changes)',
  ];

  export(exportExcelData: FinancialStatement): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(exportExcelData);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }


  getSheet(exportExcelData: FinancialStatement): XLSX.WorkSheet {
    const preparedData = getPreparedData(exportExcelData, this.headers);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    return withHeaderStyling(sheet);
  }

}
